import { makeLazyComponent } from '../../../scripts/utils';

export const LazyApiKeysPage = makeLazyComponent(
  async () =>
    (await import(/* webpackChunkName: "api-keys-page" */ './ApiKeysPage'))
      .ApiKeysPage
);
